import React from "react";
import "./forgottenPassword.css";
import { Link } from "react-router-dom";

export default function ForgottenPassword() {
  return (
    <div className="login-form-wrapper">
      <div className="text-regular">
        <p style={{ fontWeight: "700" }}>
          Zaboravljena lozinka / Obnova lozinke
        </p>
        <p>
          Za obnovu lozinke, obratite se administratoru Vaše organizacije.
        </p>
        <p>
          Administrator može da promeni Vašu lozinku kroz panel za upravljanje
          korisnicima.
        </p>
      </div>
      <Link to="/login" className="login-form-button" style={{ textAlign: "center", textDecoration: "none", marginTop: "20px" }}>
        Nazad na prijavu
      </Link>
    </div>
  );
}
